export const enum PLATFORMS {
    Europeana = 'europeana',
    NonEuropeana = 'non-europeana'
}
